import { useDisclosure } from '@mantine/hooks';
import { Modal, Button, List, Stack, Anchor, Checkbox } from '@mantine/core';
import { useEffect, useState, useContext } from 'react';
import mixpanel from 'mixpanel-browser';
import { ConfigContext } from 'src/app/ConfigContext';

export function TermsOfUseModal() {
  const { config } = useContext(ConfigContext);

  const [opened, { open, close }] = useDisclosure(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const siteName = 'this site';
  const storageKey = 'capricornTermsLastVisit';

  useEffect(() => {
    const lastVisit = localStorage.getItem(storageKey);
    const oneWeekInMilliseconds = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds

    if (
      !lastVisit ||
      Date.now() - new Date(lastVisit).getTime() >= oneWeekInMilliseconds
    ) {
      // If it's the user's first visit or a week has passed since the last visit
      open();
    }
  }, []);

  /**
   * Render list item
   * @param text - text to show
   * @returns JSX
   */
  const renderListItem = (text: string) => {
    return (
      <List.Item maw="95%" c="var(--mantine-color-text-45)">
        {text}
      </List.Item>
    );
  };

  const handleAgreeClick = () => {
    // Update the last visit timestamp
    localStorage.setItem(storageKey, new Date().toISOString());
    mixpanel.track('Terms of Service Agreed');
    close();
  };

  return (
    <Modal
      opened={opened}
      onClose={close}
      title="Terms of Service"
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
      centered
      classNames={{
        header: 'bg-transparent',
        title: 'text-[24px] font-[700] mx-auto',
      }}
    >
      <Checkbox
        fz={14}
        mb={12}
        label={
          <>
            By selecting this checkbox, I agree to the{' '}
            <Anchor target="_blank" href={config.termsOfServiceUrl} c="brand.0">
              TERMS OF SERVICE
            </Anchor>{' '}
            and to be bound by them. I also agree and warrant the following:
          </>
        }
        classNames={{
          body: 'items-center',
          inner: 'shrink-0',
        }}
        checked={isAgreed}
        onChange={(event) => setIsAgreed(event.currentTarget.checked)}
      />
      <div className="px-4 py-6 border border-solid border-white/[0.14] rounded-[16px]">
        <List c="var(--mantine-color-main-2)" fz={14} fw={400} spacing={10}>
          {renderListItem(`You are not accessing ${siteName} from a Restricted Territory as set
              forth in the Terms of Service.`)}
          {renderListItem(`You are not a person or entity who is a resident of, or is
                  located, incorporated or has a registered agent, in the United
                  States of America or a Restricted Territory.`)}
          {renderListItem(`You will not in the future access ${siteName} or otherwise trade on
              ${siteName} while located within the United States of America or a Restricted Territory.`)}
          {renderListItem(
            `You are not using, and will not in the future use, a VPN to disguise your location to access ${siteName}.`
          )}
        </List>
      </div>
      <Button
        mt={24}
        w="100%"
        size="lg"
        disabled={!isAgreed}
        onClick={handleAgreeClick}
      >
        Agree to Terms
      </Button>
    </Modal>
  );
}
